import { TransactionToken } from "types/common";

export const is0X = (raw?: string): raw is `0x${string}` =>
  raw?.indexOf("0x") === 0;

export const parse0x = (raw?: string) => {
  if (!is0X(raw)) {
    throw new Error("0x prefixed string expected");
  }

  return raw;
};

export const isTransactionToken = (raw?: string): raw is TransactionToken =>
  ["base", "quote"].some((v) => v === raw);

export const hasKey = <T extends string>(
  key: T,
  obj?: any,
): obj is Record<T, any> => !!obj && Reflect.has(obj, key);
